import { ThemeIcon, Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import type { ReactNode } from 'react';

/**
 * A small "?" info icon with a hover/tap tooltip — used across the admin panel
 * to explain what a metric, badge or process means without cluttering the UI.
 * Place it next to a heading or label.
 */
export function InfoTip({ label, w = 300 }: { label: ReactNode; w?: number }) {
  return (
    <Tooltip
      label={label}
      multiline
      w={w}
      withArrow
      events={{ hover: true, focus: true, touch: true }}
    >
      <ThemeIcon variant="subtle" color="gray" size="sm" style={{ cursor: 'help' }}>
        <IconInfoCircle size={15} />
      </ThemeIcon>
    </Tooltip>
  );
}
